// ─────────────────────────────────────────────
//  useRooms — real-time room listener for a facility
// ─────────────────────────────────────────────
import { useEffect, useState } from "react";
import { listenToRooms } from "../firebase/firestore";

export function useRooms(facilityId) {
  const [rooms, setRooms]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!facilityId) {
      // No facility (signed out / switching) — drop the previous facility's
      // rooms and stop the spinner instead of showing stale cards.
      setRooms([]);
      setLoading(false);
      setError(null);
      return undefined;
    }
    setLoading(true);
    const unsub = listenToRooms(facilityId, (snapshot) => {
      const data = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      // Sort by room name, numeric-aware within a location group so "OR 2"
      // precedes "OR 10" (D-01). Location section order is applied downstream
      // by groupRoomsByLocation (D-03); this governs within-group order only.
      data.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }));
      setRooms(data);
      setLoading(false);
    }, (err) => {
      setError(err.message);
      setLoading(false);
    });
    return unsub;
  }, [facilityId]);

  return { rooms, loading, error };
}
